<app-header4></app-header4>
<div class="page-title-area page-title-area5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="banner-content mLText">
                    <span data-animation="fadeInLeft" data-delay="0.5s" class="bienVenu">BIENVENUE À L'ISN POLYSCIENCE</span>
                    <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title">Institut des Sciences Novatrices</h1>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="intro-video-area bg_cover" style="background-image: url(assets/images/intro-video-bg.jpg);">
    <div class="intro-overlay c-background">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="intro-video-content mt-30">
                        <span class="c-pre">PRÉSENTATION</span>
                        <h2 class="title">ISN POLYSCIENCE.</h2>
                        <p class="text-1 c-ins">INSTITUT DES SCIENCES NOVATRICES.</p>
                        <p class="text-2 c-colorPresentation">L'ISN POLYSCIENCE est fondé par l'initiative de l'ancien Directeur des Etudes de l'Institut Panafricain de Formation avec l'implication de professeurs attitrés ayant déja offert des prestations de haute qualité à l'université Cheikh
                            Anta DIOP et dans les autres établissements privés de formation en santé. A travers un enseignement de qualité et novateur afin de faciliter l’insertion dans le monde professionnel, l'ISN POLYSCIENCE propose une offre de formation
                            dans plusieurs domaines.
                        </p>
                        <!-- <a class="main-btn wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".1s" routerLink='/about'>Learn More</a> -->
                    </div>
                    <!-- intro video content -->
                </div>
                <div class="col-lg-6">
                    <div class="intro-thumb mt-30">
                        <img src="assets/images/imagesAssets/pr1.png" class="c-ima" alt="">
                        <!-- <a class="video-popup" href="http://bit.ly/2VuPnrx"><i class="fas fa-play"></i></a> -->
                    </div>
                    <!-- intro thumb -->
                </div>
            </div>
            <!-- row -->
        </div>
        <!-- container -->
    </div>
</div>


<div class="quote-area bg_cover" style="background-image: url(assets/images/imagesAssets/universite.jpg);">
    <div class="quote-overlay">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="section-title-2 text-center">
                        <h2 class="title">ISN POLYSCIENCE</h2>
                        <p class="c-textt"><span class="marB"> Notre Institut tient sa raison d’être de la transformation de la formation professionnelle en Afrique.</span> <br> <span class="marB"> Cette volonté de transformation émane d’une étude de l’UNESCO qui, après avoir établi que 20%
                            des populations africaines sont constituées de jeunes âgés entre 15 et 24 ans, a aussi révélé que 40% de cette catégorie sociale est au chômage. La raison c’est l’inadéquation entre l’offre de formations et la demande
                            des employeurs.</span>
                            <br> <span class="marB"> Par ailleurs, les projections promettent 100 millions de jeunes dans le marché du travail d’ici 2030, et si rien n’est fait, les gouvernements africains auront à gérer des taux de chômage jamais connus et feront sûrement
                            face à des crises sociales avec comme catalyseurs les réseaux d’émigration clandestine. </span> <br> <span class="marB"> Conscients de ces enjeux, les 8 pays de l’UEMOA ont entamé depuis 2017 une mutualisation de leurs forces par le partage des curricula
                            de leurs programmes d’Enseignement et Formations Techniques et Professionnelles (EFTP) et des référentiels métiers.</span> <br> <span class="marB"> ISN POLYSCIENCE s’inscrit donc dans cette dynamique et propose des profils de formations conformes aux référentiels
                            adoptés au sein de l’UEMOA, souvent même de la CEDEAO et notamment dans des sciences innovantes (voir les différentes sections de formations).</span>
                        </p>
                    </div>
                    <!-- section title 2 -->
                </div>
            </div>
        </div>
        <!-- container -->
    </div>
</div>


<div class="solution-area2 bg_cover" style="background-image: url(assets/images/imagesAssets/isnStructure.jpg);">
    <div class="solution-overlay2 c-paddinT">
        <div class="container">
            <div class="row align-items-center">
                <!-- <div class="col-lg-8">
                    <div class="solution-box">
                        <div class="solution-content c-conten">
                            <h3 class="title">ORGANIGRAMME ISN</h3>
                            <div class="solution-play text-right mr-30 d-block d-lg-none">
                                <a class="video-popup" href="http://bit.ly/2VuPnrx"><i class="fas fa-play"></i></a>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="col-lg-4">
                    <div class="solution-play text-right mr-30 d-none d-lg-block">
                        <a class="video-popup" href="http://bit.ly/2VuPnrx"><i class="fas fa-play"></i></a>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>


<!-- Contact and email -->
<div class="action-2-area bg_cover" style="background-image: url(assets/images/action-bg.jpg);">
    <div class="action-overlay">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-2">
                    <div class="action-item mt-30">
                        <span>Pour plus de renseignements</span>
                        <h2 class="title2C">CONTACTEZ-NOUS.</h2>
                    </div>
                </div>
                <div class="col-lg-10">
                    <div class="action-support d-flex mt-30">
                        <div class="action-support-item wow bounceInUp" data-wow-duration=".5s" data-wow-delay=".3s">
                            <p>Email</p>
                            <span class="c-titreInfo">isninfo@isn.sn</span>
                            <i class="fal fa-envelope"></i>
                        </div>
                        <div class="action-support-item action-support-item-2 wow bounceInUp" data-wow-duration=".7s" data-wow-delay=".7s">
                            <p>Téléphone</p>
                            <span class="c-titreInfo">78 559 86 30 | 77 649 19 12 | 77 574 56 67</span>
                            <i class="fal fa-phone"></i>
                        </div>
                        <div class="action-support-item action-support-item-2 wow bounceInUp" data-wow-duration=".9s" data-wow-delay=".11s">
                            <p>Adresse</p>
                            <span class="c-titreInfo">Rond point JVC</span>
                            <i class="fal fa-home"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end Contact and email -->



<app-footer2></app-footer2>